import SplitSectionRoutine from "../components/SplitSectionRoutine";


const DailyRoutine = () => {
    return (
        <>
        <SplitSectionRoutine 
            heading="Daily routine"
            imageSrc="/porridge.png"
            backgroundColor="#e6f0f8"
            paragraphs={[
                "We start the day with a warm welcome and healthy breakfast",
                "A bowl of porridge with freshly chopped fruits on top"
            ]}
            reversed
        />
        <SplitSectionRoutine 
            heading="Then comes free play time"
            imageSrc="/play-time-collage.png"
            backgroundColor=" #F3D9E5"
            paragraphs={[
                "A variety of toys around the setting are always in reach of our little ones.",
                "Free play promotes creativity by allowing them to create their own games and get to know their own limitations and physical abilities.",
                "We do not interrupt them when they are deeply focused as this is important for immersive learning. However we are always there observing and providing the right amount of help, at the right time."
            ]}
        />
        <SplitSectionRoutine
            heading="Reading Time"
            imageSrc="/activity-9.jpg"
            backgroundColor="#e6f0f8"
            paragraphs={
                [
                    "We have a variety of books for various ages and interests. Bookshelves are at eye level of Little ones. And of course they can pick up and read whenever they like during the day however we do at least two sessions of book reading all together. We sit in a circle, read the book, discuss it before and after, and always share our ideas and relate them to our lives or daily activities. "
                ]
            }
            reversed
        />
        <SplitSectionRoutine 
            heading="Outdoor Play Time"
            imageSrc="/outdoor-collage.png"
            backgroundColor="#F3D9E5"
            paragraphs={
                [
                    "We do at least 45 minutes of outdoor play in our lovely garden, designed to suit various ages.",
                    "No matter what the weather is like, we dress appropriately and spend some active time in the garden. We believe outdoor play helps little ones’ mental, physical, emotional health and sleep, resilience and learning."
                ]
            }
        />
        <SplitSectionRoutine
            heading="Lunch Time"
            imageSrc="/activity-7.jpg"
            backgroundColor="#e6f0f8"
            paragraphs={
                [
                    "We serve ready made meals three times a day. Along with various snacks times between meals.",
                    "At lunch time children are usually served, handmade sandwiches,eggs, fruits and steamed vegetables."
                ]
            }
            reversed
        />
        <SplitSectionRoutine
            heading="Sleep and rest time"
            imageSrc="/sleep.jpg"
            backgroundColor="#F3D9E5"
            paragraphs={
                [
                    "We believe sleep and rest is essential for all children. We have a sleep room upstairs with cot beds. We play gentle music during sleep time. The best sleep time is after a busy garden play when they will need to charge up their batteries.",
                    "Children who no longer require sleep but still need to have a rest will have a calm and quiet time by being encouraged to do slow activities like reading books or doing puzzles. "
                ]
            }
        />
        <SplitSectionRoutine
            heading="Activity Time"
            imageSrc="/child-cropped.jpg"
            backgroundColor="#e6f0f8"
            paragraphs={
                [
                    "Curriculum and activities are planned based around children's interests and their next learning steps."
                ]
            }
            reversed
        />
        <SplitSectionRoutine
            heading="Dinner Time"
            imageSrc="/food_one.jpg"
            backgroundColor="#F3D9E5"
            paragraphs={
                [
                    "Homemade, warm and balanced dinner is served for the little ones, just before home time.",
                    "For dinner we usually have meatballs, salmon, or chicken along with some steamed veggies and yogurt. Please talk to us if your little one has allergies or  a dietary requirement."
                ]
            }
        />
        <SplitSectionRoutine
            heading="Home Time"
            imageSrc="/activity-2.jpg"
            backgroundColor="e6f0f8"
            paragraphs={
                [
                   "At the end of the day, we say goodbye to our little ones with as big a smile as we welcome them in the morning."
                ]
            }
            reversed
        />
        </>
    )
}

export default DailyRoutine;